import jwt_decode from "jwt-decode";
import LaJwtPayload from "../types/LaJwtPayload.type";

const ATTR_AUTH_TOKEN_STORAGE = "lapedia_auth_token";

export const getAuthToken = () => {
  return localStorage.getItem(ATTR_AUTH_TOKEN_STORAGE);
};
export const removeAuthToken = () => {
  localStorage.removeItem(ATTR_AUTH_TOKEN_STORAGE);
};

const decodeToken = (token: string): LaJwtPayload | null => {
  try {
    return jwt_decode<LaJwtPayload>(token);
  } catch {
    return null;
  }
};

export const isAuthTokenValid = (): boolean => {
  const token = getAuthToken();
  if (!token) {
    return false;
  }

  const decoded = decodeToken(token);
  if (!decoded) {
    removeAuthToken();
    return false;
  }

  return true;
};

export const fetchUserIdFromJwt = (token: string): string => {
  return decodeToken(token)?.userId || "";
};

export const fetchRoleFromJwt = (token: string): string => {
  return decodeToken(token)?.role || "";
};

export const fetchEmailFromJwt = (token: string): string => {
  return decodeToken(token)?.sub || "";
};

export const login = (jwt: string, navigate: () => void) => {
  localStorage.setItem(ATTR_AUTH_TOKEN_STORAGE, jwt);
  if (navigate) {
    navigate();
    window.location.reload();
  }
};

export const logout = (navigate?: () => void) => {
  removeAuthToken();
  if (navigate) {
    navigate();
  }
  window.location.reload();
};
